<div class="card rounded-10 shadow">
  <div class="card-header">
    <div class="card-title">Estatísticas de vendas</div>
  </div>
  <div>
    <div class="card-body" *ngIf="isLoaded">
      <app-loading-dash />
    </div>
    <div class="card-body" *ngIf="!isLoaded">
      <div class="mb-0">
        <div id="chart">
          <apx-chart
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [yaxis]="chartOptions.yaxis"
            [xaxis]="chartOptions.xaxis"
            [dataLabels]="chartOptions.dataLabels"
            [stroke]="chartOptions.stroke"
            [plotOptions]="chartOptions.plotOptions"
            [colors]="chartOptions.colors"
            [tooltip]="chartOptions.tooltip"
            [grid]="chartOptions.grid"
          ></apx-chart>
        </div>
      </div>
    </div>
  </div>
</div>
